import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

export const OfflineIndicator = () => {
  const [offline, setOffline] = useState(typeof navigator !== "undefined" && !navigator.onLine);

  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); };
  }, []);

  if (!offline) return null;

  return (
    <div data-testid="offline-indicator"
      className="fixed inset-x-0 top-0 z-[60] flex items-center justify-center gap-2 bg-primary px-4 py-2 text-center text-xs font-semibold text-primary-foreground">
      <WifiOff size={14} />
      You're offline — showing the latest saved event info.
    </div>
  );
};
